import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-credit-card',
  templateUrl: './credit-card.component.html',
  styleUrls: ['./credit-card.component.scss'],
})
export class CreditCardComponent {
  @Input() type!: 'MCCRD-SAR' | 'MCCRD-SAR-2';
  @Input() cardNumber!: string;
  @Input() cvc!: string;
  @Input() holderName!: string;
  @Input() expiryDate!: string;
  @Input() forceActivation : boolean = false;
  @Output() activateCard = new EventEmitter<void>();
  @Input() Status: 'OK' | 'Inactive' | 'Blocked' | 'Freeze' = 'OK';
  @Input() StatusDisplay: string = '';
  get getPictureUrl() {
    let url = '';
    switch (this.type) {
      case 'MCCRD-SAR':
        url = 'assets/images/creditCards/titanium.svg';
        break;
      case 'MCCRD-SAR-2':
        url = 'assets/images/creditCards/world.svg';
        break;
    }
    return url;
  }

  get _cardNumber() {
    return this.cardNumber;
    // return this.cardNumber.match(/(.{1,4})/g)?.join(' ');
  }

  get _expiryDate() {
    // let year = this.expiryDate.getFullYear().toString().slice(-2);
    // let month = ('00' + (this.expiryDate.getMonth() + 1)).slice(-2);
    let month = this.expiryDate?.split(' ')[0];
    let year = this.expiryDate?.split(' ')[1];
    if (!(month && year)) return this.expiryDate;
    return `${month} / ${year}`;
  }

  startActivation() {
    this.activateCard.emit(); 
  }
}
